import { pickBy, isUndefined } from 'lodash';

export default obj => pickBy(obj, value => !isUndefined(value));
